import { colFormRef } from './consts';
import randomId from 'random-id';

export default function (editor, opts = {}) {
  const c = opts;
  const bm = editor.BlockManager;
  const pfx = c.pfx;

  if (c.blocks.indexOf(colFormRef) >= 0) {
    bm.add(colFormRef, {
      label: `
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512" width="32" height="50">
      <path d="M416 448h-84c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h84c17.7 0 32-14.3 32-32V160c0-17.7-14.3-32-32-32h-84c-6.6 0-12-5.4-12-12V76c0-6.6 5.4-12 12-12h84c53 0 96 43 96 96v192c0 53-43 96-96 96zm-47-201L201 79c-15-15-41-4.5-41 17v96H24c-13.3 0-24 10.7-24 24v96c0 13.3 10.7 24 24 24h136v96c0 21.5 26 32 41 17l168-168c9.3-9.4 9.3-24.6 0-34z"/>
  </svg>
      <div class="gjs-block-label">${c.labelColForm}</div>`,
      category: c.labelColFormCategory,
      content: `
        <form class="form ${pfx} dc-form-default dc-form-bordered"  onsubmit="return login(event)" data-gjs-type="login-form" data-js="login-form" id="${randomId(
        4,
        '',
      )}">

        </form>
      `,
      render: ({ model, className }) => `
      <div class="${className}-label ${className}__drapcode-wrap">
      ${model.get('label')}
      </div>

      <span class="${className}__info no-doc">
        <a target="_blank" href="#" draggable="false">
          <i class="${className}__info-fa fa fa-info-circle" style="margin-left: 5px" title="Check how to use ${
        c.labelColForm
      }?"></i>
        </a>
      </span>
    `,
    });
  }
}
